export const APP_VERSION = '0.1r'
export const APP_RELEASE_LABEL = `Leveleria PWA ${APP_VERSION}`
